import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { APP_CONFIG, getAppHeader, } from '../../../configs/config';
import { POPUP_TARGET_NAME } from '../../../configs/constants';
import SharedPropsService from '../../../SharedPropsService';
import { api } from '../../../configs/api';
import { Platform } from 'react-native';
import { getParameters, nextStepCredStepper } from "../../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const authenticateRepayment = async (action, _datastore, { instrumentTrack, setDatastore }) => {
    await setDatastore(ROUTE.LOAN_AGREEMENT, "agreementInitPage", {
        loading: true
    });
    instrumentTrack('AGREEMENT_REVIEW_BUTTON_CLICKED');
    if (action.payload.value) {
        await setDatastore(ROUTE.LOAN_AGREEMENT, "agreementInitPage", {
            showClickForAgreementCard: true,
            loading: false
        });
    }
};
export const goBack = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER, {});
};
var popupOpened;
export const openLinkInNewTab = async (action, _datastore, { appendWidgets, removeWidgets, openNewTab, hidePopup, showPopup, getHeight, setDatastore, network, ...props }) => {
    await setDatastore(ROUTE.LOAN_AGREEMENT, "agreementInitPage", {
        loading: true
    });
    if (action.payload.value) {
        if (Platform.OS === 'web') {
            let isFromRnSdk = false;
            const params = getParameters(window?.location?.href);
            if (params?.isFromRnSdk) {
                isFromRnSdk = true;
            }
            const config = {
                width: 600,
                height: 600,
                target: 'Volt Money',
            };
            const left = screen.width / 2 - config.width / 2;
            const top = screen.height / 2 - config.height / 2;
            if (isFromRnSdk) {
                popupOpened = window.open(action.payload.value, '_blank', `height=${APP_CONFIG.POP_UP_SIZE.HEIGHT},width=${APP_CONFIG.POP_UP_SIZE.WIDTH}. top=${top}, left=${left}`);
            }
            else {
                popupOpened = window.open(action.payload.value, POPUP_TARGET_NAME.AGREEMENT, `height=${APP_CONFIG.POP_UP_SIZE.HEIGHT},width=${APP_CONFIG.POP_UP_SIZE.WIDTH}. top=${top}, left=${left}`);
            }
            await setDatastore(ROUTE.LOAN_AGREEMENT, "agreementInitPage", {
                showClickForAgreementCard: false,
                showWaitingForResponseCard: true,
                loading: false
            });
        }
        else {
            await setDatastore(ROUTE.LOAN_AGREEMENT, "agreementInitPage", {
                loading: false,
                showWebView: true
            });
        }
        await PollAgreementStatusAction(action, {}, {
            appendWidgets,
            removeWidgets,
            openNewTab,
            hidePopup,
            showPopup,
            getHeight,
            setDatastore,
            network,
            ...props,
        });
    }
};
let hasNavigate = false;
export const PollAgreementStatusAction = async (action, _datastore, { network, showPopup, navigateWithClear, setDatastore, removeWidgets, appendWidgets, getHeight }) => {
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const getApiLoad = async () => {
        await network
            .get(`${api.agreementStatus}${applicationId}`, {
            headers: await getAppHeader(),
        })
            .then(response => response.data)
            .then(async (response) => {
            if (response.stepResponseObject.toLowerCase() === 'success') {
                clearInterval(timerRef);
                const user = await SharedPropsService.getUser();
                user.linkedApplications[0] = response.updatedApplicationObj;
                await SharedPropsService.setUser(user);
                let applicationId;
                if (await AsyncStorage.getItem("application_id") !== null) {
                    applicationId = await AsyncStorage.getItem("application_id");
                }
                else {
                    applicationId = user.linkedApplications[0].applicationId;
                }
                const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
                await setDatastore(ROUTE.LOAN_AGREEMENT, "agreementInitPage", {
                    showWebView: false,
                });
                if (popupOpened) {
                    //@ts-ignore
                    window?.ReactNativeWebView?.postMessage("closePop");
                    popupOpened.close();
                }
                let routeObj;
                if (await AsyncStorage.getItem("application_id") !== null) {
                    routeObj = await nextStepCredStepper(updatedApplicationResponse.data.currentStepId, updatedApplicationResponse.data.stepStatusMap);
                    await setDatastore(ROUTE.LOAN_AGREEMENT, "agreementInitPage", {
                        showAgreementCompleteStatus: true,
                        showClickForAgreementCard: false,
                        showWaitingForResponseCard: false,
                        routeObj: routeObj
                    });
                    setTimeout(() => {
                        !hasNavigate && navigateWithClear(routeObj.routeId, routeObj.params);
                    }, 4000);
                }
                else {
                    const currentStepId = user.linkedApplications[0].currentStepId;
                    routeObj = await nextStepCredStepper(currentStepId);
                    await setDatastore(ROUTE.LOAN_AGREEMENT, "agreementInitPage", {
                        showAgreementCompleteStatus: true,
                        showClickForAgreementCard: false,
                        showWaitingForResponseCard: false,
                        routeObj: routeObj
                    });
                    setTimeout(() => {
                        !hasNavigate && navigateWithClear(routeObj.routeId, routeObj.params);
                    }, 4000);
                }
            }
            else if (response.stepResponseObject.toLowerCase() === 'failed') {
                clearInterval(timerRef);
                await setDatastore(ROUTE.LOAN_AGREEMENT, "agreementInitPage", {
                    showAgreementCompleteStatus: false,
                    showClickForAgreementCard: false,
                    showWaitingForResponseCard: false,
                    showAgreementFailureStatus: true,
                });
                showPopup({
                    isAutoTriggerCta: false,
                    type: 'FAILED',
                    title: 'AutoPay setup failed!',
                    subTitle: 'Bank account must be linked for AutoPay. Please try again.',
                    ctaLabel: 'Continue to try again',
                    ctaAction: {
                        type: ACTION.GO_TO_AUTOPAY,
                        routeId: ROUTE.LOAN_AGREEMENT,
                        payload: {},
                    },
                });
            }
        });
    };
    const timerRef = setInterval(() => {
        getApiLoad();
    }, APP_CONFIG.POLLING_INTERVAL);
};
export const NavToAutoPay = async (action, _datastore, { navigate, goBack, navigateWithClear }) => {
    hasNavigate = true;
    const routeObj = await nextStepCredStepper();
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const NavToLoanAgreement = async (action, _datastore, { navigate, goBack }) => {
    await navigate(ROUTE.LOAN_AGREEMENT);
};
